import React, { Component } from 'react';
import './styles/GlobalView.css';


export default class GlobalView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            isLoaded: false
        }
    }

    componentDidMount() {
        if(sessionStorage.getItem('GlobalTotalCount')) {
            this.setState({
                data: JSON.parse(sessionStorage.getItem('GlobalTotalCount')),
                isLoaded: true
            }, () => {
                this.updateGlobalData();
            })
        }
        else {
            const c = setInterval(() => {
                if(sessionStorage.getItem('GlobalTotalCount')) {
                    this.setState({
                        data: JSON.parse(sessionStorage.getItem('GlobalTotalCount')),
                        isLoaded: true
                    }, () => {
                        this.updateGlobalData();
                    })
                }
            }, 1000)
            return () => clearInterval(c);
        }
    }

    updateGlobalData = () => {
        const intvl = setInterval(() => {
            if(sessionStorage.getItem('GlobalTotalCount')) {
                this.setState({
                    data: JSON.parse(sessionStorage.getItem('GlobalTotalCount')),
                    isLoaded: true
                })
            }
        }, 600000)
        return () => clearInterval(intvl);
    }

    render() {
        return (
            <div className="global-view-wrapper">
                {
                    this.state.isLoaded ? 
                    <div id="global-view-inner-wrapper">
                        <h1 id='global-view-header'>
                            Global Stats
                        </h1>

                        <h2 className='global-view-details text-confirmed'>
                            Total Confirmed: {this.state.data.TotalConfirmed.toLocaleString()}
                        </h2>

                        <h2 className='global-view-details text-confirmed'>
                            New Confirmed: {this.state.data.NewConfirmed.toLocaleString()}
                        </h2>

                        <h2 className='global-view-details text-deaths'>
                            Total Deaths: {this.state.data.TotalDeaths.toLocaleString()}
                        </h2>

                        <h2 className='global-view-details text-recovered'>
                            Total Recovered: {this.state.data.TotalRecovered.toLocaleString()}
                        </h2>
                        
                    </div> 
                    
                    : ''
                }
            </div>
        )
    }
}
